import { Button, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { getFieldInputProps } from "core/utils/form";
import { _t } from "core/language";
// import { validationSchemaConfirmPassword } from "modules/Auth/pages/Auth.config";
import API from "core/networks/API";
import { API_UPDATE_AVATAR } from "../api";
import { useDispatch } from "react-redux";
import * as action from "modules/Auth/store/actions";
import { REGEX } from "core/config/constant";
import { useUser } from "modules/Auth/hooks";
import { useState } from "react";

const ChangeDisplayName = () => {
  const navigate = useCustomNavigate();
  const dispatch = useDispatch();
  const {userInfo} = useUser()
  const [loading, setLoading] = useState<boolean>(false);
  const formik = useFormikCustom({
    initialValues: {
      display_name: userInfo?.name,
    },
    // validationSchema:validationSchemaConfirmPassword,
    validateOnMount: false, // Prevent validation on page load (default behavior)
    validateOnChange: false, // Validate on field changes
    validateOnBlur: false,   // Validate when a field is blurred
    onSubmit(values, formikHelpers) {
      console.log(values, formikHelpers)
      handleSubmitComfirm()
      
      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });
  
  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSubmitComfirm= async () => {
    const dataRequest = {
      name: formik.values.display_name,
    }
    setLoading(true)
    try {
      const { data: response } = await API.post(`${API_UPDATE_AVATAR}`, dataRequest);
        if (response && response?.code === 200) {
          setLoading(false)
          handleGoBack()
          dispatch(action.updateInfoUser(response.data));
        }
    } catch (e: any) {
      console.log(e, 'errors')
      setLoading(false)
      if (e?.response?.data?.code === 400) {
        console.log(e, 'errors400')
      }
      if (e?.response?.data?.code === 422) {
        console.log(e, 'errors422')
      }
    }
  }

  const handleSubmit = (e: any) => {
    const { onSubmit, errors } = formik;
    console.log(errors, 'errors')
    onSubmit(e)
  };

  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader sticky title={_t('menu.changeDisplayName')} handleGoBack={handleGoBack} />
      <div className="">
        <form onSubmit={handleSubmit} className="flex flex-col px-4 py-12 w-full ">
          <div>
            <CInputControl
              className=" "
              label={_t('menu.labelDisplayName')}
              error=""
              maxLength={20}
              type="text"
              placeholder={_t('menu.placeholderDisplayName')}
              format={REGEX.DISPLAY_NAME}
              {...getFieldInputProps(formik, 'display_name')}
            />
          </div>
          <div className="absolute left-0 bottom-[60px] w-full px-4">
            <Button 
              disabled={!formik.values.display_name || formik.values.display_name.length < 4 || loading ? true : false} 
              size="lg" 
              type="submit" 
              label={_t('auth.Confirm')} 
              classBtn="w-full mb-[50px] font-medium"
              primary
            />
          </div>
        </form>
      </div >
    </AppLayout >
  );
};

export default ChangeDisplayName;
